import React from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import Header from '../components/HomePage/Header';
import Footer from '../components/HomePage/Footer';

const pathsToHideHeader = [
  'precalltest',
  '[cooperation]',
  '[cooperation]/success',
  'student/match-tutor',
  'wallet',
  'buy-hours',
  'upload',
  'app',
  'apps',
  'search-referals',
  'board',
  'payment',
  'intercom-booking',
  'intercom-scheduler',
  'intercom-tutor-orders',
  'intercom-tutor-calls',
  'intercom-call-students',
  'intercom-booking-flow',
  'intercom-calendar-table',
  'scheduler',
  'post-message',
  'mobile-booking-flow',
  'university-booking',
  'student/feedback-form',
  'mobile-booking-details',
  'expired-booking',
  'student/leaderboard',
  'student/points',
  'student/prize-wheel',
  'student/complaints-onboarding',
  'tutor/grades-onboarding',
  'mobile-profile',
  'change-phone-number',
  'change-phone-number-unavailable',
  'verify_new_phone',
  'makhfi-report',
  'almkhfai-exams',
  'connectivity-test',
  'student/post-session-analysis/[sessionClassId]',
  'student/homework',
  'student/join-session',
  'test-connectivity',
];
const pathsToHideFooter = [
  'app',
  'apps',
  'wallet',
  'search-referals',
  '[cooperation]',
  '[cooperation]/success',
  'student/match-tutor',
  '/s/',
  'buy-hours',
  'meeting',
  'precalltest',
  'upload',
  'board',
  'mylibrary',
  'intercom-scheduler',
  'intercom-tutor-orders',
  'intercom-tutor-calls',
  'intercom-call-students',
  'intercom-booking-flow',
  'intercom-calendar-table',
  'scheduler',
  'payment',
  'intercom-booking',
  'mobile-booking-flow',
  'university-booking',
  'student/feedback-form',
  'mobile-booking-details',
  'expired-booking',
  'student/leaderboard',
  'student/points',
  'student/prize-wheel',
  'student/complaints-onboarding',
  'tutor/grades-onboarding',
  'mobile-profile',
  'change-phone-number',
  'change-phone-number-unavailable',
  'verify_new_phone',
  'makhfi-report',
  'almkhfai-exams',
  'connectivity-test',
  'student/post-session-analysis/[sessionClassId]',
  'student/homework',
  'post-message',
  'student/join-session',
  'test-connectivity',

];
const Main = ({ children, ...rest }) => {
  const { pathname } = useRouter();
  const showHeader = pathsToHideHeader.every(
    (path) => !pathname.includes(path)
  );
  const showFooter = pathsToHideFooter.every(
    (path) => !pathname.includes(path)
  );

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100VH',
        justifyContent: 'space-between',
      }}
    >
    <div>
      {rest.showHeader !== false && showHeader && (
        <Header isAuth={rest.isAuth} user={rest.currentUser} />
      )}
      {children}
    </div>
      {pathname !== '/' && showFooter && <Footer />}
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentUser: state.auth.currentUser,
  showHeader: state.orderState.showHeader,
});

export default connect(mapStateToProps)(Main);
